export var resolve = function (cond, ifTrue, ifFalse) {
    return cond ? ifTrue : ifFalse;
};
export var resolveExpress = function (cond, ifTrue, ifFalse) {
    return cond ? "".concat(ifTrue !== null && ifTrue !== void 0 ? ifTrue : '') : "".concat(ifFalse !== null && ifFalse !== void 0 ? ifFalse : '');
};
export var resolveCondition = function (cond, label, value) {
    return cond ? { label: label, value: value } : {};
};
export var resolveOptCondition = function (cond, opt) {
    return cond ? opt : {};
};
export var resolveOptArrCondition = function (cond, opt) {
    return cond ? opt : [{}];
};
export var emptyBlocks = function (count, fullWidth) {
    if (count === void 0) { count = 1; }
    if (fullWidth === void 0) { fullWidth = false; }
    return Array.from({ length: count }).map(function () { return ({ type: 'emptyBlock', fullWidth: fullWidth }); });
};
export var resolveValue = function (cond, ifTrue, ifFalse) {
    return cond ? ifTrue : ifFalse;
};
